<template>
  <vs-tabs position="left" class="tabs-shadow-none">
    <vs-tab icon-pack="feather" icon="icon-code" label="Legal documents">
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <legal-documents-list />
      </div>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-home" label="GDPR setup">
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <data-processors />
      </div>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-terminal" label="Cookies">
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <cookies />
      </div>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-bookmark" label="Cookie popup">
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <cookie-popup />
      </div>
    </vs-tab>
  </vs-tabs>
</template>

<script>
import DataProcessors from "./DataProcessors.vue";
import LegalDocumentsList from "./LegalDocumentsList.vue";
import Cookies from "./Cookies/Cookies.vue";
import CookiePopup from "./CookiePopup/CookiePopup.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    DataProcessors,
    LegalDocumentsList,
    Cookies,
    CookiePopup,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({}),
  },
};
</script>

<style lang="scss">
#profile-tabs {
  .vs-tabs--content {
    padding: 0;
  }
}
</style>